import en from "element-plus/es/locale/lang/en";

const enLocale = {
  ...en,
  el: {
    colorpicker: {
      confirm: "Confirm",
      clear: "Clear",
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "Confirm",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start date",
      startTime: "Start time",
      endDate: "End date",
      endTime: "End time",
      prevYear: "Previous year",
      nextYear: "Next year",
      prevMonth: "Previous month",
      nextMonth: "Next month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec",
      },
    },
  },
  test: "ทดสอบ",
  thai: "ไทย",
  english: "en",
  email: "E-mail",
  password: "Password",
  forgot: "forgot password?",
  or: " or ",
  login: "Login",
  loginPlus: "Login with S+",
  loginPlusV5: "Login with S+ V5",
  loading: "Loading",
  waiting: "Please wait.",
  sendingData: "We are sending your information",
  hello: "Hello,",
  riskScore: "Risk Score",
  getRiskTitle: "Get Your Risk Score",
  getRiskDesc1: "Know your risk score from",
  getRiskDesc2: "health risk assessment.",
  noRisk: "You don't have any risk.",
  questionNo: "Step",
  outOf: "of",
  nothaverisksuggest: `
    Health check-up depends on age, overall health, congenital disease, family history. and lifestyle of each individual Basic health check-up programs are generally divided into: by gender and age The doctor recommends regular examinations every 1 year. For those with risk factors requiring special surveillance, additional examinations may be required. <br/>
- Age 20 years and over, all genders, have annual health check at least once a year <br/> <br/> `,
  nothaverisksuggest2: `
  Health check-up depends on age, overall health, congenital disease, family history. and lifestyle of each individual Basic health check-up programs are generally divided into: by gender and age The doctor recommends regular examinations every 1 year. For those with risk factors requiring special surveillance, additional examinations may be required. <br/>
- Age 20 years and over, all genders, have annual health check at least once a year <br/> <br/>
*** Note: Age 20 years and over, female, cervical cancer screening. It was found to be number one among Thai women. Regular screening for cervical cancer makes it possible to detect it at an early stage and treat it. can begin to be examined at the beginning of sexual intercourse <br/>
*** If there are symptoms of cancer, diabetes, hypertension and heart disease, no reassessment of risk assessments will be concluded. It is recommended to choose a general health check-up package.
`,
  noRiskNew: `Note: Age 20 years and over, all genders, have annual health check at least once a year If there are symptoms of cancer, diabetes, hypertension and heart disease, no reassessment of risk assessments will be concluded. It is recommended to choose a general health check-up package.`,
  testAgain: "Test Again",
  getRiskButton: "Take the test",
  healthPackage: "Health Package",
  seeAll: "See all",
  bundlePackage: "Bundle Package",
  yourPersonalizePackage: "Your personalized package",
  suggest: "Suggest for you",
  search: "Search",
  notFound: "We couldn't find the package you are looking for?",
  nothave: "No recommended packages now",
  nothavePack: "The package you selected does not exist.",
  searching1: "In Processing to personalize",
  searching2: "your Health Packages",
  packageForYou: "Package For You",
  choosehospital: "Choose Hospital",
  location: "Location",
  dateAppointment: "Date",
  checkTheDetail: "Please check the detail",
  appdate: "Date",
  sukhumvit: "Samitivej Sukhumvit",
  srinakarin: "Samitivej Srinakarin",
  sriracha: "Samitivej Sriracha",
  thonburi: "Samitivej Thonburi",
  chonburi: "Samitivej Chonburi",
  chinatown: "Samitivej Chinatown",
  sukhumvitHospital: "Samitivej Sukhumvit Hospital",
  srinakarinHospital: "Samitivej Srinakarin Hospital",
  srirachaHospital: "Samitivej Sriracha Hospital",
  thonburiHospital: "Samitivej Thonburi Hospital",
  chonburiHospital: "Samitivej Chonburi Hospital",
  chinatownHospital: "Samitivej Chinatown Hospital",
  SVH: "Sukhumvit",
  SNH: "Srinakarin",
  SSH: "Sriracha",
  STH: "Thonburi",
  SCH: "Chonburi",
  SCT: "Chinatown",
  pleasSelect: "Please select ",
  pleasSelect2: " before selelct this package",
  // pleaseUnselect: "Have some details same as another package",
  pleaseUnselect:
    "This package has included in another package that you already selected.",
  someDetailDup:
    "* This package has included in another package that you already selected.",
  pleaseUnselect2: "please only select this package",
  pleasOptSelect: "cheaper when buying with",
  prerequisiteCategory: "Prerequisite Package",
  prerequisiteCategoryฺBeforeDiscount: "Bundle Package",
  recommend: "Recommend",
  selectAll: "Select all",
  total: "Total",
  baht: "Baht",
  skip: "skip",
  start: "Let's start",
  syncData: "Sync your data from Samitivej",
  yesSync: "Yes",
  noSync: "No",
  next: "Next",
  questionatitle:
    "Take this Health Assessment to help us analyze your Risk Score and personalize your Health Plan",
  sex: "What was your sex at birth?",
  male: "Male",
  female: "Female",
  dateofbirth: "Date of birth?",
  date: "Date",
  month: "Month",
  year: "Year",
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",
  career: "Career",
  ผู้บริหาร: "Board of directors",
  ธุรกิจส่วนตัว: "Business owner",
  พนักงานรัฐ: "State enterprise officer",
  พนักงานบริษัท: "Office worker",
  นักกีฬา: "Athlete",
  ว่างงาน: "Unemployed",
  "นักเรียน/นักศึกษา": "Student",
  อื่นๆ: "Others",
  specify: "Please specify",
  pleaseFill: "Please fill in all information.",
  bodyDetail: "Your body details?",
  height: "Height",
  weight: "Weight",
  bmi: "BMI",
  waistline: "Waistline",
  centimeter: "cm",
  kilogram: "kg",
  kmpermg: "kg/m²",
  inch: "inch",
  yourRisk: "You have ",
  compareWithNormal: " risk compared to the average people",
  moreSuggestionButton: "More Suggestion",
  //// healthdetail
  healthdetail: "Your health details?",
  optional: "(optional)",
  bloodpressure: "Blood Pressure",
  sbp: "Systolic Blood Pressure",
  dbp: "Diastolic Blood Pressure",
  cholesterol: "Cholesterol",
  cholesterolLDL: "Low-density Lipoprotien (LDL)",
  bloodsugar: "Fasting Blood Sugar (FBS)",
  HbA1c: "Hemoglobin A1C; HbA1C",
  mmhg: "mmHg",
  mgdl: "mg/dL",
  pleaseFillDiseaseCompletely: "Please fill out the information completely.",
  //// behavior
  behavior: "Do you have any of the following behaviors?",
  snoring: "Snoring with tiredness after waking up",
  alcohol: "Drink alcohol more than 2 glasses/day",
  // healthcheck: "Last health check is less than 1 year",
  healthcheck: "Last health check-up within 1 year",
  healthcheck2: "is less than 1 year",
  nothealthcheck: "Never had a health check",
  smoking: "Smoking",
  airPollution: "Air Pollution",
  morethanone:
    "You can select more than 1 answer. If you don't have these behaviors, you can press next.",
  //// disease
  do: "Do ",
  you: "you",
  disease: " have a history of the following diseases?",
  cancer: "Cancer",
  diabete: "Diabetes",
  hypertension: "Hypertension",
  cvd: "Cardiovascular",
  kidney: "Kidney disease",
  stroke: "Stroke",
  metabolic: "Metabolic syndrome",
  none: "No medical problems",
  other: "Others",
  pleaseFillDisease: "Please Fill.",
  morethanonedisease: "( You can select more than 1 answer. )",
  morethanonedisease2:
    "( You can select more than 1 answer. If you don't have these symtoms, select no medical problems. )",
  suggestedisease:
    "* If there are symptoms of disease as listed below There will be no risk assessment for such diseases. recommend to customers Choose a general health check-up package",
  suggestedisease2:
    "*  If there are symptoms of cancer, diabetes, hypertension and heart disease, no reassessment of risk assessments will be concluded. It is recommended to choose a general health check-up package.",
  //// family disease
  family: "your family",
  famdisease: " have a history of the following diseases?",
  //// main
  mainReason:
    "Let’s start by thinking about why activity is important to you. What’s the main reason you chose it?",
  loseWeight: "Lose weight",
  moreActive: "More active",
  activeTrack: "Active and want to stay on track",
  overallHealth: "Active is important for overall health",
  //// exercise
  exercise: "How many times do you exercise per week?",
  lessThan3day: "Less than 3 days",
  d3To5: "3-5 days",
  d6To7: "6-7 days",
  dontdo: "I never exercise",
  select: "Select day",
  //// exercise time
  exercisetime: "How much time do you do exercise per time?",
  less15: "Less than 15 mins",
  f15t30: "15-30 mins",
  f30t1: "30 mins - 1 hr",
  more1: "more than 1 hr",
  sportsTrain: "Do you regularly do any sports training or competitions?",
  yes: "Yes",
  no: "No",
  //// Assessment Report
  cvdlevel1: "Low Risk",
  cvdlevel2: "Moderate Risk",
  cvdlevel3: "High Risk",
  cvdlevel4: "High Risk",
  cvdlevel5: "High Risk",
  dmlevel1: "Low Risk",
  dmlevel2: "Moderate Risk",
  dmlevel3: "High Risk",
  dmlevel4: "High Risk",
  dmlevel5: "High Risk",
  ccalevel1: "Low Risk",
  ccalevel2: "Moderate Risk",
  ccalevel3: "High Risk",
  gotohome: "Back to Home",
  yourisklevelof: "Your risk level of ",
  suggest50y:
    "* In people aged over 45 years, colorectal cancer screening should be screened by endoscopy to prevent and find abnormalities before it spreads.",
  ////Packageforyou
  notFillDate: "Please select the appointment date",
  notFillPhoneNumber: "Please fill in the phone number",
  notFillDate2: "Please select the 2nd appointment date",
  notSelectHospital: "Please select hospital",
  pleaseSelectHos: "Please select hospital",
  notequalDate:
    "The appointment date and the 2nd appointment date couldn't be the same.",
  thank:
    "Your Package reservation has been successfully completed. Should  there be any changes, our staff will get in touch with you.",
  withYourPhoneNumber: "<p>with your phone number<br>within 48 hours.</p>",
  addtocart: "Add to cart",
  pay: "Check Out",
  pickDate: "Pick date",
  makeAppointment: "Make Appointment",
  wating: "Please wait a moment...",
  seedetail: "See detail",
  hideDetail: "Hide detail",
  alreadyBuy: "* You have already bought this package in the past 1 year.",
  //qrcode
  save: "Save",
  share: "Share",
  scan: "Scan QR Code",
  packageDetail: "Package Details",
  tutorial: "Tutorial",
  //Checkout
  checkout: "Confirm",
  confirmCheckout: "Confirm",
  payment: "Payment",
  coupon: "Coupon",
  applyCoupon: "Apply Coupon",
  coin: "Coin",
  coins: "Coins",
  useCoins: "Use coins",
  cointoBaht: "10 Coins = 1 Baht",
  discount: "discount",
  haveCoins: "you have",
  paymentMethods: "Payment Methods",
  creditDebit: "Credit/Debit",
  addNewCard: "Add new card",
  mobileBanking: "Mobile Banking",
  payWith: "Pay with K PLUS",
  scb: "Pay with K PLUS",
  // cart
  cart: "Cart",
  myOrder: "My Order",
  Complete: "Complete",
  toPay: "to be paid",
  complete: "to be paid",
  orderNumber: "Order Number",
  RiskAssessment: "Your Risk Assessment Report",
  // confirm-popup
  confirm: "confirm",
  edit: "edit",
  //  noted for thai people
  forThai:
    "* Special price for Thai nationals and foreigners residing in Thailand only. Must schedule an appointment 3 days prior to service",
  // flash sale
  flashSale: "Promotion Flash Sale 12.12",
  flashSaleDesc: "Grab 5 % Discount on Samitivej's Well Health Packages,",
  flashSaleDesc2: "Available on 12 December 2023 from 00:01 AM ",
  flashSaleDesc3: "to 13 December 2023 11:59 PM only!",
  flashSaleRemark:
    "Remark: Once the booking of the package is completed, you will receive a 5% discount coupon attached to the confirmation email. Please present this coupon at the payment counter of the hospital where you receive the service to redeem the 5% discount.",
  flashSaleRemark2:
    "For further inquiries, please contact our Line Official Account: @WellbySamitivej",
  gotoHealthPackages: "Go to Health Packages",
  // new home
  doYouKnowYourRisk: "What health risks do you have ?",
  findOutYourRisk:
    "To better find appropriate health prevention and health screening tool.",
  doTheTest: "Take the test ",
  findPackage: "Find health packages",
  branch: "branch",
  popularPackage: "Popular health packages ",
  suggestHeader: "Suggest for you",
  bookYourPackage: "Health package",
  analyzedPackage: "We select the appropriate package from health assessment",
  riskTitle: "Risk level",
  seeMore: "more detail",
  seeLess: "hide detail",
  morePackage: "Recommended additional health packages",
  appointmentDateil: "Appointment detail",
  allAppointment: "All Appointment",
  appointmentNumber: "Appointment no.",
  appointmentDate: "Appointment date",
  appointmentLocation: "Location",
  nextAppointment: "Upcoming",
  selectAppointmentDate: "Appointment date",
  telephoneNumber: "Telephone Number",
  selectPackage: "Add package",
  inProgress: "Evaluating …",
  inProgressMessage:
    "Please wait a moment . We are using your information to evaluate",
  inProgressMessage2: "the package that is right for you.",
  addItem: "Add package",
  appointmentDetIl: "Appointment Detail",
  healthCheckup: "Health Checkup",
  package: "Package",
  manyPackage: "Packages",
  timeOclock: "",
  changeBranch: "Change branch",
  mostRecommend: "Recommend",
  // showAllPackage
  filter: "Filter",
  clearFilter: "Clear",
  filterCategory: "Category",
  filterBy: "Please select category",
  recentlyFilter: "Recently",
  recommendFilter: "Recommend",
  allPackage: "All packages",
  sortBy: "Sort by",
  seacrhPlaceHolder: "Symptoms, Package Name",
  // booking
  healthPackageBooking: "Health checkup",
  alreadyGetInformation: "We have your information.",
  // Appointment
  name: "Name",
  me: "(Me)",
  hospitalVisit: "Hospital Visit",
  contactUs:
    "To inquire more information or request change of appointment, please contact representative at",
  BEST_SELLER: "Popular Packages",
  STH_RECOMMEND: "Recommended Packages",
  RECOMMEND: "Recommended Packages",
};

export default enLocale;
